import { Hotkey } from "../../../../../../ui/hotkey/component.js";
import { LivePlaybackHotkeys } from "../live-playback-hotkeys.js";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
//#region src/internal/skins/shared/skins/shared/live-video/hotkeys.tsx
/** @jsxImportSource react */
function LiveVideoHotkeys({ disabled = false } = {}) {
	return /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx(LivePlaybackHotkeys, { disabled }),
		/* @__PURE__ */ jsx(Hotkey, {
			disabled,
			keys: "f",
			action: "toggleFullscreen"
		}),
		/* @__PURE__ */ jsx(Hotkey, {
			disabled,
			keys: "c",
			action: "toggleSubtitles"
		}),
		/* @__PURE__ */ jsx(Hotkey, {
			disabled,
			keys: "i",
			action: "togglePictureInPicture"
		})
	] });
}
//#endregion
export { LiveVideoHotkeys };

//# sourceMappingURL=hotkeys.js.map